import { useNavigate, useRouter } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/hooks/useTranslation'
import { getDefaultNavigationUrl } from '@/lib/navigation-utils'
import useAuth from '@/hooks/use-auth'

export default function NotFoundError() {
  const navigate = useNavigate()
  const { history } = useRouter()
  const { t } = useTranslation()
  const { user, hasPermission } = useAuth()

  const handleBackToHome = () => {
    const userPermissions = user?.permissions?.map(p => p.name) || [];
    const targetUrl = getDefaultNavigationUrl(userPermissions, hasPermission);
    navigate({ to: targetUrl });
  };

  return (
    <div className='h-svh'>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        <h1 className='text-[7rem] leading-tight font-bold'>{t('errors.notFound.title')}</h1>
        <span className='font-medium'>{t('errors.notFound.heading')}</span>
        <p className='text-muted-foreground text-center'>
          {t('errors.notFound.message')}
        </p>
        <div className='mt-6 flex gap-4'>
          <Button variant='outline' onClick={() => history.go(-1)}>
            {t('errors.notFound.goBack')}
          </Button>
          <Button onClick={handleBackToHome}>{t('errors.notFound.backToHome')}</Button>
        </div>
      </div>
    </div>
  )
}
